import { Box, Grid, List, makeStyles, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { useDocumentStore } from "@roc/feature-documents";
import { formatCurrency } from "@roc/ui/utils";
import { isNil } from "@roc/feature-utils";
import { Button, Paper, PaperBorderType } from "@roc/ui";
import EditIcon from '@material-ui/icons/Edit';
import { EditPayoffFieldsDialog } from "./dialogComponents/editPayoffFieldsDialog";
import { divider, listItem } from "./cardComponents/payoffCardListItem";

const useStyles = makeStyles((theme: Theme) => ({

}));

export const PayoffFieldsCard = observer(({ }) => {
  const classes = useStyles();
  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore },
    },
  } = useDocumentStore();

  return (
    <>
      <Paper titleComponent={
        <Box display="flex" p={2}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography variant="h5">
                Payoff
              </Typography>
            </Grid>
            <Grid item>
              <Button
                testId="editPayoffFields"
                variant="outlined"
                size="small"
                color="primary"
                onClick={() => payoffCalculatorStore.setIsEditPayoffFieldsDialogOpen(true)}
                startIcon={<EditIcon />}
                disabled={payoffCalculatorStore?.isPrePayoffCalculator}
              >
                Edit
              </Button>
            </Grid>
          </Grid>
        </Box>
      } borderType={PaperBorderType.SOLID_BORDER}>
        <Grid container style={{ padding: '0px 16px 16px' }} spacing={2}>
          <Grid item xs={6}>
            <List style={{ padding: '0px' }}>
              {listItem('Good Through Date', payoffCalculatorStore?.payoffCalculatorData?.loanPayoffData?.goodThroughDate ?? '-')}
              {divider}
              {listItem('Reserve Fees if Any', !isNil(payoffCalculatorStore?.payoffCalculatorData?.reserveFees) ? formatCurrency(payoffCalculatorStore?.payoffCalculatorData?.reserveFees) : '-')}
              {divider}
              {listItem('To Charges Principal', !isNil(payoffCalculatorStore?.payoffCalculatorData?.toChargesPrincipal) ? formatCurrency(payoffCalculatorStore?.payoffCalculatorData?.toChargesPrincipal) : '-')}
              {divider}
              {listItem('Waiver Amount', !isNil(payoffCalculatorStore?.payoffCalculatorData?.loanPayoffData?.waiverAmount) ? formatCurrency(payoffCalculatorStore?.payoffCalculatorData?.loanPayoffData?.waiverAmount) : '-')}
              {divider}
              {listItem('Waiver description', payoffCalculatorStore?.payoffCalculatorData?.loanPayoffData?.waiverDescription ?? '-')}
              {divider}
              {listItem('Total Cross Interest', !isNil(payoffCalculatorStore?.payoffCalculatorData?.crossInterest) ? formatCurrency(payoffCalculatorStore?.payoffCalculatorData?.crossInterest) : '-')}
              {divider}
              {listItem('Cross Interest Detail', payoffCalculatorStore?.payoffCalculatorData?.loanPayoffData?.crossInterestDetail ?? '-')}
            </List>
          </Grid>
          <Grid item xs={6}>
            <List style={{ padding: '0px' }}>
              {listItem('Unpaid Balance', !isNil(payoffCalculatorStore?.payoffCalculatorData?.fundedAmount) ? formatCurrency(payoffCalculatorStore?.payoffCalculatorData?.fundedAmount) : '-')}
              {divider}
              {listItem('Total extension fee', !isNil(payoffCalculatorStore?.payoffCalculatorData?.totalExtensionFee) ? formatCurrency(payoffCalculatorStore?.payoffCalculatorData?.totalExtensionFee) : '-')}
              {divider}
              {listItem('Prepayment penalty', !isNil(payoffCalculatorStore?.payoffCalculatorData?.loanPayoffData?.prepaymentPenalty) ? formatCurrency(payoffCalculatorStore?.payoffCalculatorData?.loanPayoffData?.prepaymentPenalty) : '-')}
              {divider}
              {listItem('Other Fees', !isNil(payoffCalculatorStore?.payoffCalculatorData?.loanPayoffData?.otherFeesAdjustment) ? formatCurrency(payoffCalculatorStore?.payoffCalculatorData?.loanPayoffData?.otherFeesAdjustment) : '-')}
              {divider}
              {listItem('Other Fees Categories', payoffCalculatorStore?.payoffCalculatorData?.loanPayoffData?.otherFeesCategories ?? '-')}
              {divider}
              {listItem('Comments', payoffCalculatorStore?.payoffCalculatorData?.loanPayoffData?.payoffComments ?? '-')}
              {divider}
            </List>
          </Grid>
        </Grid>
      </Paper>
      <EditPayoffFieldsDialog />
    </>
  );
});